// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"0869940e","271":"b0626f7f","316":"b5bfb076","368":"f70d6aca","822":"cd6b3498"}[chunkId] + ".chunk.js";
};